import { GridRowId } from '@mui/x-data-grid-premium'
import { GridApiPremium } from '@mui/x-data-grid-premium/models/gridApiPremium'
import { RefObject } from 'react'

// Cell
export const checkAndStartCellEditMode = (apiRef: RefObject<GridApiPremium>, id: GridRowId, field: string) => {
  const isEditing = apiRef.current?.getCellMode(id, field) === 'edit'
  if (!isEditing) {
    apiRef.current?.startCellEditMode({ id, field })
  }
}

export const checkAndStopCellEditMode = (apiRef: RefObject<GridApiPremium>, id: GridRowId, field: string) => {
  const isEditing = apiRef.current?.getCellMode(id, field) === 'edit'
  if (isEditing) {
    apiRef.current.stopCellEditMode({ id, field })
  }
}

// Row
export const checkAndStartRowEditMode = (apiRef: RefObject<GridApiPremium>, id: GridRowId) => {
  const isEditing = apiRef.current?.getRowMode(id) === 'edit'
  if (!isEditing) {
    apiRef.current?.startRowEditMode({ id })
  }
}

export const checkAndStopRowEditMode = (apiRef: RefObject<GridApiPremium>, id: GridRowId, ignoreModifications?: boolean) => {
  const isEditing = apiRef.current?.getRowMode(id) === 'edit'
  if (isEditing) {
    apiRef.current.stopRowEditMode({ id, ignoreModifications: ignoreModifications ?? false })
  }
}
